import React, { useState } from 'react';
import { X, Calendar } from 'lucide-react';
import axios, { API } from '../../utils/api';
import { PollOptionsEditor, PollClosingTime, pollOptionsPayload, pollOptionsBusy } from './PollOptionsEditor';

const BORDER = '#E5E7EB';
const todayIST = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);

export default function EditPollModal({ event, onClose, onSaved }) {
  const [options, setOptions] = useState(() => (event.options || []).map(o => ({ id: o.id, text: o.text || '', image_url: o.image_url || null })));
  const [closingDate, setClosingDate] = useState(event.closing_date || '');
  const [closingTime, setClosingTime] = useState(event.closing_time || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    const payload = pollOptionsPayload(options);
    if (payload.length < 2) { setError('Please add at least 2 voting options'); return; }
    setSaving(true);
    setError('');
    try {
      await axios.put(`${API}/hr/admin-events/${event.id}`, {
        options: payload, closing_date: closingDate || null, closing_time: closingDate && closingTime ? closingTime : null,
      });
      onSaved();
    } catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Could not save the poll. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const busy = saving || pollOptionsBusy(options);
  return (
    <div data-testid="edit-poll-modal" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: '#FFF', borderRadius: 16, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto', padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Edit poll</h2>
          <button onClick={onClose} aria-label="Close" data-testid="edit-poll-close" style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} /></button>
        </div>
        <p style={{ margin: '0 0 14px', fontSize: 13, color: '#6B7280' }}>{event.title} · editing is possible only until the first vote.</p>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Voting Options *</label>
        <PollOptionsEditor options={options} setOptions={setOptions} />
        <div style={{ marginTop: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 8 }}>
            <Calendar size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: 'middle' }} />Closing Date (optional)
          </label>
          <input type="date" value={closingDate} min={todayIST()} onChange={(e) => setClosingDate(e.target.value)} data-testid="edit-poll-closing-date"
            style={{ width: '100%', padding: 12, borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, boxSizing: 'border-box' }} />
          <PollClosingTime value={closingTime} onChange={setClosingTime} disabled={!closingDate} />
        </div>
        {error && <div data-testid="edit-poll-error" style={{ marginTop: 12, padding: '8px 12px', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, fontSize: 13, color: '#B91C1C' }}>{error}</div>}
        <button onClick={save} disabled={busy} data-testid="edit-poll-save"
          style={{ width: '100%', marginTop: 16, padding: 14, borderRadius: 8, border: 'none', background: busy ? BORDER : '#4DB6AC', color: '#FFF', fontSize: 14, fontWeight: 600, cursor: busy ? 'not-allowed' : 'pointer' }}>
          {saving ? 'Saving…' : 'Save changes'}
        </button>
      </div>
    </div>
  );
}
